import Image from '@atoms/Image/Image';
import { LikeButtonVariants } from '@atoms/LikeButton/LikeButton';
import Text from '@atoms/Text/Text';
import CardTypeEnum from '@models/enums/CardTypeEnum';
import { IProductTile, IProductTileHeading } from '@models/IProductTile';
import AddToMyListButton from '@molecules/AddToMyListButton/AddToMyListButton';

const HeadingAndCategory = ({
  displayCategory,
  heading,
}: IProductTileHeading) => (
  <>
    {displayCategory && (
      <Text
        variant="body-small"
        as="span"
        className="tw-mb-2 tw-uppercase tw-text-grey-70"
      >
        {displayCategory}
      </Text>
    )}
    <Text
      as="p"
      variant="ds-headline-4"
      className="tw-font-light tw-text-grey-100"
    >
      {heading}
    </Text>
  </>
);

const ProductTile = ({
  image,
  displayCategory,
  heading,
  intro,
  keyBenefits,
  url,
  standardNameId,
  id,
  wishlistDrawerLabels,
}: IProductTile) => {
  const hasKeyBenefits = keyBenefits && keyBenefits.length > 0;

  const handleTracking = () => {
    const trackingObject = window.tracking ?? {};

    window.dataLayer.push({
      event: 'trackingEvent_select_item',
      event_name_variable: 'select_item',
      trackingEvent_select_item: {
        item_name: heading,
        item_id: standardNameId,
        item_cms_id: id,
        item_category: displayCategory,
        item_category2: 'product',
      },
      customer_info: {
        user_industry: trackingObject.industryNameForPageLoadTracking,
        user_sub_industry: trackingObject.subIndustryNameForPageLoadTracking,
        user_region: trackingObject.regionForPageLoadTracking,
        target_audience: trackingObject.targetAudienceForPageLoadTracking,
      },
    });
  };

  return (
    <article className="tw-relative tw-flex tw-h-full tw-w-full tw-flex-col tw-bg-grey-10">
      <AddToMyListButton
        cardId={id}
        collection={CardTypeEnum.Colours}
        wishlistDrawerLabels={wishlistDrawerLabels}
        buttonVariant={LikeButtonVariants.Bordered}
        isCard
      />
      <a href={url} onClick={handleTracking}>
        <div className="tw-aspect-[16/10] tw-content-center">
          {image?.url ? (
            <Image image={{ ...image }} classes="tw-p-4" />
          ) : (
            <div className="tw-flex tw-h-full tw-flex-col tw-justify-end tw-bg-grey-20 tw-p-4">
              <HeadingAndCategory
                displayCategory={displayCategory}
                heading={heading}
              />
            </div>
          )}
        </div>

        {(image?.url || intro || hasKeyBenefits) && (
          <div className="tw-flex tw-flex-grow tw-flex-col tw-px-4 tw-pb-6">
            {image?.url && (
              <HeadingAndCategory
                displayCategory={displayCategory}
                heading={heading}
              />
            )}

            <Text
              variant="body-small"
              as="p"
              className="tw-mt-4 tw-text-grey-80"
            >
              {intro}
            </Text>
            {hasKeyBenefits && (
              <div className="tw-mt-6 tw-text-grey-70">
                <ul className="tw-list-['–'] tw-pl-1.5">
                  {keyBenefits.map((benefit) => (
                    <Text
                      as="li"
                      variant="body-small"
                      className="tw-mb-1 tw-list-outside tw-pl-1.5"
                      key={benefit}
                    >
                      {benefit}
                    </Text>
                  ))}
                </ul>
              </div>
            )}
          </div>
        )}
      </a>
    </article>
  );
};

export default ProductTile;
